import React from 'react'
import classNames from 'classnames'

import { ReactComponent as PlanIcon } from '../../../assets/svg/icons/plan-icon.svg'
import '../../../assets/sass/components/plans/plan-header.scss'

const PlanHeader = ({
    plan = "gold",
    icon: Icon = PlanIcon,
    title = 'Gold Account',
    subtitle = 'Subscription Expiring on 12/31/2021',
}) => {
    return (
        <div className={classNames("plan-header", plan)}>
            <div className="icon-container">
                <Icon className="icon" />
            </div>
            <div className="message-container">
                <h4 className="title">{title}</h4>
                <span className="subtitle">{subtitle}</span>
            </div>
        </div>
    )
}

export default PlanHeader
